<template>
    <div>
      <button @click="googleSignIn">Sign in with Google</button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'GoogleLogin',
    data() {
      return {
        isGapiLoaded: false,
      };
    },
    methods: {
      googleSignIn() {
        if (this.isGapiLoaded && window.gapi && window.gapi.auth2) {
          const authInstance = window.gapi.auth2.getAuthInstance();
          
          if (authInstance) {
            authInstance.signIn().then((googleUser) => {
              // Handle successful sign-in
              const profile = googleUser.getBasicProfile();
              const userId = profile.getId();
              const userName = profile.getName();
              console.log('Signed in user:', userName, userId);
              // Handle further sign-in logic (e.g., send data to your server)
            }).catch((error) => {
              console.error('Google Sign-In failed:', error);
            });
          }
        } else {
          console.error('Google API or auth2 not loaded yet');
        }
      }
    },
    mounted() {
      // Ensure gapi is ready
      if (window.gapi) {
        window.gapi.load('auth2', () => {
          const authInstance = window.gapi.auth2.getAuthInstance();
          if (authInstance) {
            this.isGapiLoaded = true;
          }
        });
      }
    }
  };
  </script>
  
  <style scoped>
  button {
    padding: 10px;
    background-color: #4285f4;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #3367d6;
  }
  </style>
  